<quill-editor
  [ngModel]="value"
  (onContentChanged)="onContentChanged($event)"
  (onBlur)="onTouched()"
  [placeholder]="placeholder"
  [readOnly]="disabled"
  [modules]="modules"
  [formats]="formats"
  [styles]="editorStyles">
</quill-editor>
